const CookieNames = {
  AUTH_ERR_COUNT: 'auth_err_count',
};

export default CookieNames;
